import levenshtein from 'fast-levenshtein';
/**
 * Знаходить найбільш схожий об'єкт за полем fildName
 */
export const findMostSimilarItem = <T>(items:T[], fildName:keyof T, searchTerm:string) => {
  if (!items.length) return undefined;

  let bestMatch = items[0];
  let smallestDistance = levenshtein.get((bestMatch[fildName] as string).toLowerCase(), searchTerm.toLowerCase());

  for (let i = 1; i < items.length; i++) {
    const currentItem = items[i];
    const currentDistance = levenshtein.get(
      (currentItem[fildName] as string).toLowerCase(),
      searchTerm.toLowerCase()
    );

    if (currentDistance < smallestDistance) {
      smallestDistance = currentDistance;
      bestMatch = currentItem;
    }
  }

  return bestMatch;
};

/**
 * Рекурсивно шукає в об'єкті перший ключ, що збігається з key без урахування регістру
 */
export const findDeepValue = (obj: unknown, key: string): unknown => {
  if (obj === null || typeof obj !== 'object') return undefined;

  for (const [ k, v ] of Object.entries(obj)) {
    if (k.toLowerCase() === key.toLowerCase()) return v;
    if (v !== null && typeof v === 'object') {
      const found = findDeepValue(v, key);
      if (found !== undefined) return found;
    }
  }
  return undefined;
};
